import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import tributeServices from "../../services/tributeServices";
import ImageWithFallback from "../ImageWithFallback";
import "../RichTextEditor/richtext.css";

const SectionBox = styled(Box)({
  padding: "0.5rem 0 1.5rem 0",
  backgroundColor: "#f8fafc",
});

const SectionSubtitle = styled(Typography)({
  textAlign: "center",
  color: "#666",
  marginBottom: "2.5rem",
});

const StyledCard = styled(Card)({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
  transition: "transform 0.2s, box-shadow 0.2s",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: "0 8px 30px rgba(0,0,0,0.1)",
  },
});

const StyledCardMedia = styled(CardMedia)({
  height: 260,
  objectFit: "cover",
});

const stripHtml = (html) => {
  if (!html) return "";
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

const HomeTribute = () => {
  const [tributes, setTributes] = useState([]);

  useEffect(() => {
    tributeServices
      .get()
      .then((res) => setTributes(res?.data?.data || []))
      .catch(() => setTributes([]));
  }, []);

  const latest = Array.isArray(tributes) ? tributes[0] : null;
  if (!latest) {
    return (
      <SectionBox component="section" id="tribute">
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            fontWeight="bold"
            textAlign="center"
            gutterBottom
            color="rgba(26,128,200)"
            sx={{ mb: 1 }}
          >
            Tributes
          </Typography>

          <SectionSubtitle>
            In loving memory of our community members
          </SectionSubtitle>

          <Typography textAlign="center" color="#666">
            No tributes are available at this time.
          </Typography>

          <Box sx={{ textAlign: "center", mt: 3 }}>
            <Button
              component={Link}
              to="/tributes"
              variant="outlined"
              color="primary"
              endIcon={<ArrowForwardIcon />}
              size="large"
            >
              View all tributes
            </Button>
          </Box>
        </Container>
      </SectionBox>
    );
  }

  return (
    <SectionBox component="section" id="tribute">
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          gutterBottom
          color="rgba(26,128,200)"
          sx={{ mb: 1 }}
        >
          Tributes
        </Typography>
        <SectionSubtitle>In loving memory of our community members</SectionSubtitle>

        <Card component={Link} to={`/tributes/${latest._id}`} sx={{ textDecoration: "none", display: "block", mb: 3 }}>
          <CardActionArea>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: "stretch" }}>
              <Box sx={{ width: { xs: "100%", md: 560 }, height: { xs: 380, md: 520 }, flexShrink: 0 }}>
                <ImageWithFallback
                  path={latest.image}
                  alt={latest.name || "Tribute"}
                  style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                />
              </Box>
              <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", p: 3 }}>
                {latest.shortStatement && (
                  <Typography variant="subtitle1" color="#666" sx={{ mb: 1 }}>
                    {latest.shortStatement}
                  </Typography>
                )}
                <Typography variant="body1" color="#333" sx={{ lineHeight: 1.6 }}>
                  {stripHtml(latest.description).slice(0, 200)}
                  {stripHtml(latest.description).length > 200 ? "..." : ""}
                </Typography>
                <Typography variant="body2" color="rgba(26,128,200)" sx={{ mt: 2, fontWeight: 600 }}>
                  View tribute →
                </Typography>
              </CardContent>
            </Box>
          </CardActionArea>
        </Card>

        <Box sx={{ textAlign: "center", mt: 2 }}>
          <Button
            component={Link}
            to="/tributes"
            variant="outlined"
            color="primary"
            endIcon={<ArrowForwardIcon />}
            size="large"
          >
            View all tributes
          </Button>
        </Box>
      </Container>
    </SectionBox>
  );
};

export default HomeTribute;
